import Vue from 'vue';
import 'vanilla-cookieconsent/dist/cookieconsent.js';
export default Vue.extend({
    created() {
        const cc = window.initCookieConsent();
        cc.run({
            revision: 1,
            page_scripts: true,
            languages: {
                en: {
                    consent_modal: {
                        description: 'We use cookies on our website to see how you interact with it. By accepting, you agree to our use of such cookies. <a href="/privacy-policy">Privacy Policy</a>',
                        primary_btn: {
                            text: 'Accept',
                            role: 'accept_all',
                        },
                        secondary_btn: {
                            text: 'Settings',
                            role: 'settings',
                        },
                    },
                    settings_modal: {
                        title: 'Advanced Cookie Settings',
                        save_settings_btn: 'Save',
                        accept_all_btn: 'Accept all',
                        blocks: [
                            {
                                title: 'Essential Cookies',
                                description: 'These cookies enable core functionality such as security, verification of identity and network management. These cookies can’t be disabled.',
                                toggle: {
                                    value: 'all',
                                    enabled: true,
                                    readonly: true,
                                },
                            },
                            {
                                title: 'Enable Analytics Cookies',
                                description: 'These cookies help us to understand how visitors interact with our website, discover errors and provide a better overall analytics.',
                                toggle: {
                                    value: 'analytics',
                                    enabled: false,
                                    readonly: false,
                                },
                            },
                        ],
                    },
                },
            },
        });
    },
});
